import React from 'react';
import {AppContext} from '../App/AppProvider';

export default function (props) {
  return <AppContext.Consumer>
    {({coinList, prices, firstVisit}) => {
      if(!coinList) {
        return <div> Loading Coins</div>
      }
      // if we are not in the firstVisit and we do NOT have prices.
        //=> show the loading indicator for the 'prices'
      if (!firstVisit && !prices) {
        return <div> Loading Prices </div>
      }
    return <div>{props.children}</div>
    }}
  </AppContext.Consumer>
}